'use strict';

module.exports = function () {
    // PIK-202006-88 - Function to show and hide elements of store list by selectedCountry and selectedState
    function showAndHideList(selectedCountry, selectedState) {
        var selection = '';

        if (selectedCountry) {
            selection = selectedCountry;
        }
        if (selectedState) { // if we have state we also have country
            selection = selection + '-' + selectedState;
        }

        // hide all
        var idCountry = 'div[id^="storeList-countryID-"]';
        var idState = 'div[id^="storeList-stateID-"]';
        var idStore = 'div[id^="storeList-storeID-"]';
        var idOutletStore = 'div[id^="storeOutletList-storesOutletID-"]';
        $(idCountry).hide();
        $(idState).hide();
        $(idStore).hide();
        $(idOutletStore).hide();

        // show only selectedCountry and selectedState
        idCountry = 'div[id^="storeList-countryID-' + selectedCountry + '"]';
        idStore = 'div[id^="storeList-storeID-' + selection + '"]';
        if (!selectedState) {
            idState = 'div[id^="storeList-stateID-' + selectedCountry + '"]';
        } else {
            var comunitie = $(idStore).data('comunitie');
            idState = 'div[id^="storeList-stateID-' + selectedCountry + '-' + comunitie + '"]';
        }
        idOutletStore = 'div[id^="storeOutletList-storesOutletID-' + selection + '"]';
        $(idCountry).show();
        $(idState).show();
        $(idStore).show();
        $(idOutletStore).show();
    }

    // PIK-202006-88 - Filter stores by country when user change the select country value
    $('select[name=storeList-countries-select]').change(function () {
        $('#store-list-select-state').val('');
        $('option[id^="selectState-"]').hide();

        // Using wrap with to avoid bad behaviour with IOS select and show/hide
        $('option[id^="selectState-"]').map(function () {
            return $(this).parent('span').length === 0 ? this : null;
        }).wrap('<span>').hide();

        var selectedCountry = $('select[name=storeList-countries-select]').val();
        var selectedState = $('select[name=storeList-states-select]').val();

        showAndHideList(selectedCountry, selectedState);

        // Using wrap with to avoid bad behaviour with IOS select and show/hide
        $('option[id^="selectState-' + selectedCountry + '-"]').unwrap().show(); // show state by country
    });

    // PIK-202006-88 - Filter stores by country-state when user change the select state value
    $('select[name=storeList-states-select]').change(function () {
        var selectedCountry = $('select[name=storeList-countries-select]').val();
        var selectedState = $('select[name=storeList-states-select]').val();

        showAndHideList(selectedCountry, selectedState);
    });

    // PIK-202006-88 - Hide all the options of the states select
    $('#store-list-select-state option').each(function () {
        var val = $(this).val();
        if (val) {
            // Using wrap with to avoid bad behaviour with IOS select and show/hide
            $(this).wrap('<span>').hide();
        }
    });

    /**
     * Add secundary image.
     */
    $('.image-container').hover(function () {
        $(this).find('.tile-imagestore-second').addClass('imagestore-d-show');
    }, function () {
        $(this).find('.tile-imagestore-second').removeClass('imagestore-d-show');
    });
};
